import styled from 'styled-components'


export const Div = styled.div`

    a {
        font-weight: bold;
        color: black;
        text-transform: uppercase;

        :hover {
            cursor: pointer;
            font-style: italic;
        }
    }
`